import _get from "lodash/get";
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import immutable from 'immutable';
/**
* Taking required data from state for further passing as props
*
* @param  {Object|Function} [options = {}] - options
* @return {Object} - taken part of state
*/

function mapSelectedStateToProps() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (state, props) {
    var stateProps = typeof options === 'function' ? options(props, state) : options;
    var map = Object.keys(stateProps).reduce(function (localState, propName) {
      var root = stateProps[propName][0];
      var path = stateProps[propName].slice(1);
      if (state[root] === undefined) console.error("Unable to find '".concat(root, "' in state keys: ").concat(Object.keys(state))); // eslint-disable-line

      var part = state[root];
      if (path.length) {
        part = immutable.Iterable.isIterable(state[root]) ? state[root].getIn(path) : _get(state[root], path);
      }
      return _objectSpread({}, localState, _defineProperty({}, propName, part));
    }, {});
    return map;
  };
}
export default mapSelectedStateToProps;